import { GiftCardDto } from "./giftCard.dto";

export interface GiftCardTransferResponseDto {
  success: boolean;
  result?: GiftCardDto;
  message?: string;
}
